import React, { createContext, useEffect, useState } from 'react'
import { ObtenerArbolActivos } from '../../helpers/ActivosHelper'
import { TreeView } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import { Add, AddCircleOutlineRounded, Build, DeleteOutlineRounded, Edit, EditAttributes, NoteAddOutlined } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { ModalAgregaActivoComponent } from '../../components/activos/ModalAgregaActivoComponent';
import { DatosInstalacionComponent } from '../../components/activos/DatosInstalacionComponent';
import { GaleriaInstalacionesComponent } from '../../components/activos/GaleriaInstalacionesComponent';
import { ModalCambiaPadreComponent } from '../../components/activos/ModalCambiaPadreComponent';


export const ActivosContext = createContext();

export const ActivosPage = () => {
const [activos, setActivos] = useState([]);
const [editandoInstalacion, setEditandoInstalacion] = useState(false);
const [modalAgregaActivo, setModalAgregaActivo] = useState(false);
const [activoSeleccionado, setActivoSeleccionado] = useState();
const [instalacionEditando, setInstalacionEditando] = useState();
const [modalCambiarNodo, setModalCambiarNodo] = useState(false)

    const obtenerActivos =() => {
        ObtenerArbolActivos().then(datos=>setActivos(datos));
      }   

    useEffect(() => {
      if(!modalAgregaActivo) {
        obtenerActivos();
      }
    }, [modalAgregaActivo])

    useEffect(() => {
      console.log('instalacion seleccionada', activoSeleccionado)
    }, [activoSeleccionado])
    
    
 
        useEffect(() => {
            obtenerActivos();
        }, [])
        
        useEffect(() => {
           // renderTree(activos);
        }, [activos])
        
        const iconoNodo = () => {
            return (
            <EmojiTransportationIcon style={{fontSize:15}} />
            )
        }

        const agregarActivo = (nodo) => {
          console.log('agregar nodo a ', nodo);
          setActivoSeleccionado(nodo);
          setModalAgregaActivo(true);

        }
        const eliminarActivo = (idNodo) => {
          console.log('eliminar nodo', idNodo);


        }
        
        const renderTree = (nodo) =>  (
                <TreeItem  
                  onClick={() => setActivoSeleccionado(nodo)}
                  key={nodo.key} nodeId={nodo.key} label={
                    <div
                        style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}
                    >
                      <div
                        style={{
                          display:'flex',
                          flexDirection:'row'
                        }}
                      >
                          {iconoNodo()}
                          <Typography
                              style={{fontSize:13, marginLeft:5}}
                          >
                          {nodo.title+' ('+nodo.key+')'}

                          </Typography>
                        </div>
                        <div>
                          <IconButton
                            onClick={(e) => {e.stopPropagation(); agregarActivo(nodo)}}
                          >
                            <AddCircleOutlineRounded style={{fontSize:15, color:'green'}} />
                          </IconButton>

                          <IconButton
                            onClick={(e) => {e.stopPropagation(); setActivoSeleccionado(nodo); setModalCambiarNodo(true)}}
                          >
                            <Edit style={{fontSize:15, color:'green'}} />
                          </IconButton>
                          <IconButton
                            onClick={(e) => {console.log('click en eliminar'); eliminarActivo(nodo.key); e.stopPropagation()}}
                          >
                          </IconButton>
                        </div>
                    </div>
                }>
                  {Array.isArray(nodo.children)
        ?  nodo.children?.map(node => renderTree(node))
        : null}
                </TreeItem>
              )
            
if(activos?.length) {
  return (
    <ActivosContext.Provider value={{
      modalAgregaActivo, setModalAgregaActivo, activoSeleccionado, editandoInstalacion, setEditandoInstalacion, setActivoSeleccionado,
      setInstalacionEditando, instalacionEditando, obtenerActivos, modalCambiarNodo, setModalCambiarNodo
    }}>
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        flex:1,
        backgroundColor:'transparent',
        marginBottom:'20',
        padding:20
    //    height:'100%'
      }}
    >
    <div
    style={{
        display:'flex',
        flexDirection:'column',
        flex:1,
          color:'black',
          marginTop:10,
          marginLeft:40,
          marginRight:20,
      //    height:'100%'
      }}    
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'space-between',
    //      maxWidth:700,
        }}
      >

        <span
            style={{
              fontSize:40,
              fontWeight:'bold'
            }}
            >
            Instalaciones
        </span>
        <span
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}
        >
 
        </span>
      </div>
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          flex:1,
        //  height:'100%'
        }}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'column',
            flex:40,
            overflowY:'auto',
            maxHeight:'80vh'
      //      height:'100%'
          }}
        >
          <TreeView
            aria-label="rich object"
            defaultCollapseIcon={<ExpandMoreIcon />}
            //defaultExpanded={['1']}
            //defaultExpanded={true}
            defaultExpandIcon={<ChevronRightIcon />}
            
            sx={{ height: '100%', flexGrow: 1, maxWidth: 400, overflowY: 'auto', backgroundColor:'white', padding:1, borderRadius:10, paddingTop:3 }}
            >
            {
              activos?.map(nodo => (
                renderTree(nodo)
                
                ))
              }
          </TreeView>
        </div>
        <div
          style={{
            display:'flex',
            flexDirection:'column',
            flex:60,
            backgroundColor:'white',
            borderRadius:10,
            maxWidth:800
          //  height:'100%'
          }}
        >
          <DatosInstalacionComponent instalacion={activoSeleccionado} />
          <GaleriaInstalacionesComponent instalacion={activoSeleccionado} />
        </div>
    </div>
    </div>
    </div>
    <ModalAgregaActivoComponent  />
    <ModalCambiaPadreComponent />
    </ActivosContext.Provider>
  )
    }
}
